import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirm-cancel',
    templateUrl: './confirm-cancel.component.html',
    styleUrls: ['./confirm-cancel.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmCancelComponent {}